<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="68px" @submit.prevent>
      <el-row>
        <el-col>
          <el-form-item prop="type">
            <el-radio-group v-model="queryParams.type" size="large" @change="handleQuery('toggle')">
              <el-radio-button label="0">{{ $t('location.area') }}</el-radio-button>
              <el-radio-button label="1">{{ $t('location.prefecture') }}</el-radio-button>
              <el-radio-button label="2">{{ $t('location.district') }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="queryParams.type !== '0'">
        <el-col>
          <el-form-item :label="queryParams.type === '1' ? $t('location.area') : $t('location.prefecture')">
            <keep-result-select
              v-if="queryParams.type === '1'"
              style="width: 100%"
              :placeholder="$t(`${$t('location.area')}${$t('global.plsSelect')}`)"
              v-model="queryParams.parentId"
              :list="locationAreaList"
              labelKey="name"
              valueKey="id"
            />
            <keep-result-select
              v-if="queryParams.type === '2'"
              style="width: 100%"
              :placeholder="$t(`${$t('location.prefecture')}${$t('global.plsSelect')}`)"
              v-model="queryParams.parentId"
              :list="locationPrefectureList"
              labelKey="name"
              valueKey="id"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="name">
        <el-input
          v-model="queryParams.name"
          :placeholder="$t('location.locationSearch')"
          clearable
          v-ctrl-enter="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="Search" @click="handleQuery">{{ $t('global.search') }}</el-button>
        <el-button icon="Refresh" @click="resetQuery">{{ $t('global.reset') }}</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5" v-if="queryParams.type === '0'">
        <el-button
          type="primary"
          plain
          icon="Plus"
          @click="handleAdd"
          v-hasPermi="['ep2:locationArea:add']"
        >{{ $t('global.add') }}</el-button>
      </el-col>
      <el-col :span="1.5" v-if="queryParams.type === '1'">
        <el-button
          type="primary"
          plain
          icon="Plus"
          @click="handleAdd"
          v-hasPermi="['ep2:locationPrefecture:add']"
        >{{ $t('global.add') }}</el-button>
      </el-col>
      <el-col :span="1.5" v-if="queryParams.type === '2'">
        <el-button
          type="primary"
          plain
          icon="Plus"
          @click="handleAdd"
          v-hasPermi="['ep2:locationDistrict:add']"
        >{{ $t('global.add') }}</el-button>
      </el-col>
      <!-- <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="Edit"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['ep2:location:edit']"
        >{{ $t('global.edit') }}</el-button>
      </el-col> -->
      <el-col :span="1.5" v-if="queryParams.type === '0'">
        <el-button
          type="danger"
          plain
          icon="Delete"
          disabled
          @click="handleDelete"
          v-hasPermi="['ep2:locationArea:remove']"
        >{{ $t('global.delete') }}</el-button>
      </el-col>
      <el-col :span="1.5" v-if="queryParams.type === '1'">
        <el-button
          type="danger"
          plain
          icon="Delete"
          disabled
          @click="handleDelete"
          v-hasPermi="['ep2:locationPrefecture:remove']"
        >{{ $t('global.delete') }}</el-button>
      </el-col>
      <el-col :span="1.5" v-if="queryParams.type === '2'">
        <el-button
          type="danger"
          plain
          icon="Delete"
          disabled
          @click="handleDelete"
          v-hasPermi="['ep2:locationDistrict:remove']"
        >{{ $t('global.delete') }}</el-button>
      </el-col>
      <el-col :span="1.5" v-if="queryParams.type === '0'">
        <el-button
          type="warning"
          plain
          icon="Download"
          @click="handleExport"
          v-hasPermi="['ep2:locationArea:export']"
        >{{ $t('global.export') }}</el-button>
      </el-col>
      <el-col :span="1.5" v-if="queryParams.type === '1'">
        <el-button
          type="warning"
          plain
          icon="Download"
          @click="handleExport"
          v-hasPermi="['ep2:locationPrefecture:export']"
        >{{ $t('global.export') }}</el-button>
      </el-col>
      <el-col :span="1.5" v-if="queryParams.type === '2'">
        <el-button
          type="warning"
          plain
          icon="Download"
          @click="handleExport"
          v-hasPermi="['ep2:locationDistrict:export']"
        >{{ $t('global.export') }}</el-button>
      </el-col>
      <!-- <right-toolbar v-model:showSearch="showSearch" @queryTable="getList"></right-toolbar> -->
    </el-row>

    <el-table ref="multipleTable" v-loading="loading" :data="locationList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="ID" prop="id"></el-table-column>
      <el-table-column :label="queryParams.type === '1' ? $t('location.sort') : $t('location.districtSort')" align="center" prop="sort" v-if="queryParams.type !== '0'" />
      <el-table-column :label="columnText[queryParams.type]" align="center" prop="name" />
      <el-table-column :label="$t('location.nameKana')" align="center" prop="nameKana" v-if="queryParams.type === '2'" />
      <!-- <el-table-column :label="$t('location.title') + $t('global.status')" align="center" prop="status">
        <template #default="scope">
          <dict-tag :options="sys_normal_disable" :value="scope.row.status" />
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('global.operation')" align="center" class-name="small-padding fixed-width">
        <template #default="scope">
          <el-button
            v-if="queryParams.type === '0'"
            link
            type="primary"
            icon="Edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['ep2:locationArea:edit']"
          >{{ $t('global.edit') }}</el-button>
          <el-button
            v-if="queryParams.type === '1'"
            link
            type="primary"
            icon="Edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['ep2:locationPrefecture:edit']"
          >{{ $t('global.edit') }}</el-button>
          <el-button
            v-if="queryParams.type === '2'"
            link
            type="primary"
            icon="Edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['ep2:locationDistrict:edit']"
          >{{ $t('global.edit') }}</el-button>
          <el-button
            v-if="queryParams.type === '0'"
            :disabled="true"
            link
            type="primary"
            icon="Delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['ep2:locationArea:remove']"
          >{{ $t('global.delete') }}</el-button>
          <el-button
            v-if="queryParams.type === '1'"
            :disabled="true"
            link
            type="primary"
            icon="Delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['ep2:locationPrefecture:remove']"
          >{{ $t('global.delete') }}</el-button>
          <el-button
            v-if="queryParams.type === '2'"
            :disabled="true"
            link
            type="primary"
            icon="Delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['ep2:locationDistrict:remove']"
          >{{ $t('global.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      v-model:page="queryParams.pageNum"
      v-model:limit="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改地址对话框 -->
    <el-dialog :title="title" v-model="open" width="500px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" :label-width="queryParams.type === '0' ? '80px' : '120px'" @submit.prevent>
        <el-form-item :label="$t('global.upperLocation')" :prop="[typeMappingFunc.parent[this.queryParams.type]]" v-if="parseInt(queryParams.type) > 0">
          <!-- <el-input v-model="form.name" placeholder="请输入上级地区" /> -->
          <keep-result-select
              :placeholder="$t(`${$t('movie.isJapaneseMovie')}${$t('global.plsSelect')}`)"
              v-model="form[typeMappingFunc.parent[this.queryParams.type]]"
              :list="queryParams.type === '1' ? locationAreaList : locationPrefectureList"
              labelKey="name"
              valueKey="id"
            />
        </el-form-item>
        <el-form-item :label="$t('location.name')" prop="name">
          <el-input v-model="form.name" :placeholder="$t('location.name') + $t('global.plsInput')" />
        </el-form-item>
        <el-form-item :label="queryParams.type === '1' ? $t('location.sort') : $t('location.districtSort')" prop="sort" v-if="queryParams.type !== '0'">
          <el-input-number v-model="form.sort" :placeholder="$t('location.sort') + $t('global.plsInput')" controls-position="right" style="width: 200px;" />
        </el-form-item>
        <el-form-item :label="$t('location.nameKana')" prop="nameKana" v-if="queryParams.type === '2'">
          <el-input v-model="form.nameKana" :placeholder="$t('location.nameKana') + $t('global.plsInput')" />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="submitForm">{{ $t('global.confirm') }}</el-button>
          <el-button @click="cancel">{{ $t('global.cancel') }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  listLocationArea, getLocationArea, delLocationArea, addLocationArea, updateLocationArea,
} from '@/api/ep2/locationArea';
import {
  listLocationDistrict, getLocationDistrict, delLocationDistrict, addLocationDistrict, updateLocationDistrict,
} from '@/api/ep2/locationDistrict';
import {
  listLocationPrefecture, getLocationPrefecture, delLocationPrefecture, addLocationPrefecture, updateLocationPrefecture,
} from '@/api/ep2/locationPrefecture';
import selectMixin from '@/utils/useSelect.js';

export default {
  name: 'Location',
  mixins: [selectMixin],
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 地址表格数据
      locationList: [],
      locationAreaList: [],
      locationPrefectureList: [],
      locationDistrictList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 50,
        name: null,
        type: '0',
        parentId: null,
      },
      // 表单参数
      form: {},
      typeMappingFunc: {
        list: {
          '0': listLocationArea,
          '1': listLocationPrefecture,
          '2': listLocationDistrict,
        },
        detail: {
          '0': getLocationArea,
          '1': getLocationPrefecture,
          '2': getLocationDistrict,
        },
        add: {
          '0': addLocationArea,
          '1': addLocationPrefecture,
          '2': addLocationDistrict,
        },
        update: {
          '0': updateLocationArea,
          '1': updateLocationPrefecture,
          '2': updateLocationDistrict,
        },
        delete: {
          '0': delLocationArea,
          '1': delLocationPrefecture,
          '2': delLocationDistrict,
        },
        parent: {
          '1': 'areaId',
          '2': 'prefectureId',
        },
        parentIdx: {
          '1': '0',
          '2': '1',
        },
        export: {
          '0': '/ep2/locationArea/export',
          '1': '/ep2/locationPrefecture/export',
          '2': '/ep2/locationDistrict/export',
        },
      },
      // 表单校验
      rules: {
        name: [
          { validator: this.$validateEmpty(this.$t('location.name') + this.$t('global.plsInput'), true), required: true, trigger: 'blur' },
        ],
        nameKana: [
          { validator: this.$validateEmpty(), trigger: 'blur' },
        ],
        areaId: [
          {
            required: true,
            message: this.$t('global.upperLocation') + this.$t('global.plsInput'),
            trigger: 'change',
          },
        ],
        prefectureId: [
          {
            required: true,
            message: this.$t('global.upperLocation') + this.$t('global.plsInput'),
            trigger: 'change',
          },
        ],
      },
      columnText: {
        '0': this.$t('location.area'),
        '1': this.$t('location.prefecture'),
        '2': this.$t('location.district'),
      },

      sys_normal_disable: null,
    };
  },
  created() {
    this.sys_normal_disable = this.useDict('sys_normal_disable').sys_normal_disable;
    this.getList();
  },
  methods: {
    /** 查询地址列表 */
    getList() {
      this.isSyncingSelection = true;
      this.loading = true;
      this.typeMappingFunc.list[this.queryParams.type]({
        ...this.queryParams,
        parentId: null,
        ...Number(this.queryParams.type) > 0 ? {
          [this.typeMappingFunc.parent[this.queryParams.type]]: this.queryParams.parentId,
        } : {},
      }).then((response) => {
        this.locationList = response.rows;
        if (Number(this.queryParams.type) < 2) {
          if (this.queryParams.type === '0' && this.locationAreaList.length === 0) this.locationAreaList = response.rows;
          if (this.queryParams.type === '1' && this.locationPrefectureList.length === 0) this.locationPrefectureList = response.rows;
        }
        this.total = response.total;
        this.loading = false;
        const _this = this;
        this.$nextTick(() => {
          _this.syncSelection(this.locationList);
          this.isSyncingSelection = false; // 重置标志
        });
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        parentId: null,
        ancestors: null,
        name: null,
        sort: null,
        status: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        delFlag: null,
      };
      this.resetForm('form');
    },
    /** 搜索按钮操作 */
    handleQuery(type) {
      this.queryParams.pageNum = 1;
      if (type === 'toggle') {
        this.ids = [];
        this.queryParams.parentId = null;
      }
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm');
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selectionChange(this.locationList, selection);
    },
    /** 新增按钮操作 */
    async handleAdd() {
      if (this.queryParams.type !== '0') {
        this.loading = true;
        await this.typeMappingFunc.list[this.typeMappingFunc.parentIdx[this.queryParams.type]]({
          pageNum: 0,
          pageSize: 99999,
        }).then((response) => {
          this.queryParams.type === '1'
            ? this.locationAreaList = response.rows.map((item) => ({ id: item.id, name: item.name }))
            : this.locationPrefectureList = response.rows.map((item) => ({ id: item.id, name: item.name }));
          this.loading = false;
        });
      }
      this.reset();
      this.open = true;
      this.title = this.columnText[this.queryParams.type] + this.$t('global.add');
    },
    /** 修改按钮操作 */
    async handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids;
      this.loading = true;
      this.queryParams.type !== '0' && await this.typeMappingFunc.list[this.typeMappingFunc.parentIdx[this.queryParams.type]]({
        pageNum: 0,
        pageSize: 99999,
      }).then((response) => {
        this.queryParams.type === '1'
          ? this.locationAreaList = response.rows.map((item) => ({ id: item.id, name: item.name }))
          : this.locationPrefectureList = response.rows.map((item) => ({ id: item.id, name: item.name }));
        // this.loading = false;
      });
      await this.typeMappingFunc.detail[this.queryParams.type](id).then((response) => {
        this.loading = false;
        this.form = response.data;
        this.open = true;
        this.title = this.columnText[this.queryParams.type] + this.$t('global.edit');
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            this.typeMappingFunc.update[this.queryParams.type](this.form).then(() => {
              this.$modal.msgSuccess(this.$t('global.editSuccess'));
              this.open = false;
              this.getList();
            });
          } else {
            this.typeMappingFunc.add[this.queryParams.type]({
              name: this.form.name,
              [this.typeMappingFunc.parent[this.queryParams.type]]: this.form[this.typeMappingFunc.parent[this.queryParams.type]],
              status: '0',
              ...this.queryParams.type === '2' ? {
                sort: this.form.sort,
                nameKana: this.form.nameKana,
              } : {},
            }).then(() => {
              this.$modal.msgSuccess(this.$t('global.addSuccess'));
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm(`${this.$t('global.confirmDelete')}${ids}？`).then(() => {
        this.typeMappingFunc.delete[this.queryParams.type](ids).then(() => {
          this.getList();
          this.$modal.msgSuccess(this.$t('global.deleteSuccess'));
          this.ids = [];
          this.multiple = true;
        });
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download(this.typeMappingFunc.export[this.queryParams.type], {
        ...this.queryParams,
      }, `location_${new Date().getTime()}.xlsx`);
    },
    // 根据不同类表获取数据
    selectType() {
      this.getList();
    },
  },
};
</script>
